/**
 * Returns true if the device used is Android
 */
export const height = 60;


